<template>

<div class="error-container">
  <div class="error">
    <p>Page not found.</p>

    <p>The page you are looking for may not exist,
      or is temporarily unavailable.
    </p>

    <P>Please <button @click="$router.go(-1)">click here</button> to return to the previous page,
      or use any of the links in the navigation menu to explore
      the <span>{{ dxaFull }}</span> collection.
    </p>
  </div>
</div>

</template>

<script>

export default { 
  name: "ErrorPage",
  data() {
    return {
      dxaFull: process.env.VUE_APP_DXA_FULL
    }
  }
}

</script>

<style lang="scss">

.error-container {
  @include flex-center;
  flex-direction: column;
  width: 100%;
  background-color: white;
}
  .error {
    width: 50%;
    padding: 50px;
  }
    .error p {
      margin-bottom: 15px;
    }
    .error button {
      @include button-styles;
      color: $link-blue;
      text-decoration: underline;
    }
    .error span {
      font-style: italic;
    }

@media only screen and (max-width: 1199px) {
  .error {
    width: 70%;
  }
}

@media only screen and (max-width: 974px) {
  .error {
    width: 80%;
  }
}

@media only screen and (max-width: 849px) {
  .error {
    width: 88%;
  }
}

@media only screen and (max-width: 724px) {
  .error {
    width: 100%;
  }
}

@media only screen and (max-width: 599px) {
  .error {
    padding: 30px;
  }
}

</style>
